import { NavLink } from 'react-router-dom';
export default NavLink;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_umi@2.6.8@umi/lib/navlink.js
// module id = 1182
// module chunks = 0